import alertKeys from 'features/localization/keys/Alerts.json';
import bidKeys from 'features/localization/keys/Bids.json';
import commonKeys from 'features/localization/keys/Common.json';
import dashboardKeys from 'features/localization/keys/Dashboard.json';
import filterPanelKeys from 'features/localization/keys/FilterPanel.json';
import offerContractKeys from 'features/localization/keys/OffersContracts.json';
import positionKeys from 'features/localization/keys/Positions.json';
import producerKeys from 'features/localization/keys/Producers.json';
import useLocalizer from './useLocalizer';

export function localizeAlert(key: keyof typeof alertKeys, options: object = null) {
  return useLocalizer(alertKeys, key, options, 'Alerts');
}

export function localizeBid(key: keyof typeof bidKeys, options: object = null) {
  return useLocalizer(bidKeys, key, options, 'Bids');
}

export function localizeCommon(key: keyof typeof commonKeys, options: object = null) {
  return useLocalizer(commonKeys, key, options, 'Common');
}

export function localizeDashboard(key: keyof typeof dashboardKeys, options: object = null) {
  return useLocalizer(dashboardKeys, key, options, 'Dashboard');
}

export function localizeFilterPanel(key: keyof typeof filterPanelKeys, options: object = null) {
  return useLocalizer(filterPanelKeys, key, options, 'FilterPanel');
}

export function localizeProducer(key: keyof typeof producerKeys, options: object = null) {
  return useLocalizer(producerKeys, key, options, 'Producers');
}

export function localizePositions(key: keyof typeof positionKeys, options: object = null) {
  return useLocalizer(positionKeys, key, options, 'Positions');
}

export function localizeOfferContract(key: keyof typeof offerContractKeys, options: object = null) {
  return useLocalizer(offerContractKeys, key, options, "Offers&Contracts");
}